<template>
    <div id="view">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-coffee"></i> Comments</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column">
                <comments-table :page="page" @search="onSearch" @sort="onOrderBy" @pageChanged="onPageChanged" :total="total" v-bind:items="comments" v-bind:actions="true"></comments-table>
            </div>
        </div>          
    </div>  
</template>

<script>
import CommentRepo from '../../repos/CommentRepo'
import lodash from 'lodash'
import CommentsTable from "./Table";

export default {
  name: 'comments-view',
  components: {CommentsTable},
  data() {
        return {
            repo: new CommentRepo(this.$auth),
            comments: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1,
        }
  },
  created(){
    this.getUsers();
  },
  methods: {
    onSearch(q){
        this.page = 1;
        this.q = q;
        this.getUsers();
    },
    onOrderBy(orderBy){
        this.page = 1;
        this.orderBy = orderBy;
        this.getUsers();
    },
    onPageChanged(page){
        this.page = page;        
        this.getUsers();
    },
    getUsers(){
        this.repo.paginate(this.page, this.q, this.orderBy).then(response => {            
            this.comments = response.data.data;
            this.total = response.data.meta.pagination.total_pages            
        });         
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/comments/View.vue